import { createReducer, on } from '@ngrx/store';
import { ISchool } from 'src/app/core/models/academic';
import { resetAppState } from '../global/global.actions';
import { SchoolActions } from './school.actions';

export const itemsFeatureKey = 'schools';

export interface SchoolState {
    selectedSchool: ISchool | null;
    schools: ISchool[];
    loading: boolean;
    error: any;
}

export const initialSchoolState: SchoolState = {
    selectedSchool: null,
    schools: [],
    loading: false,
    error: null,
};

export const schoolReducer = createReducer(
    initialSchoolState,
    on(SchoolActions.selectSchool, (state, { id }) => ({
        ...state,
        selectedSchool: state.schools.find(school => school.id === id) || null
    })),
    on(SchoolActions.loadSchools, state => ({
        ...state,
        loading: true,
        error: null
    })),
    on(SchoolActions.loadSchoolsSuccess, (state, { schools }) => ({
        ...state,
        schools: schools,
        loading: false
    })),
    on(SchoolActions.loadSchoolsFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error: error
    })),
    on(resetAppState, () => initialSchoolState)
);
